// extracted by mini-css-extract-plugin
export default {"notifications-footer":"NotificationsFooter_notifications-footer__ruIqU"};